import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@src/app/shared/shared.module';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { AuthHandlerComponent } from './auth-handler/auth-handler.component';
import { PublicRoutingModule } from './public-routing.module';

@NgModule({
    declarations: [AuthHandlerComponent],
    imports: [CommonModule, SharedModule, PublicRoutingModule, NzSkeletonModule],
})
export class PublicModule {}
